import { api } from "../../lib/api";

export interface Sgi {
  id: string;
  name: string;
  code: string | null;
  country: string | null;
  defaultCommissionRate: string | null;
  vatRate: string | null;
  active: boolean;
  createdAt: string;
}

export interface CreateSgiInput {
  name: string;
  code?: string | null;
  country?: string;
  defaultCommissionRate?: string;
  vatRate?: string;
}

export const listSgis = () => api<{ data: Sgi[] }>("/admin/sgis").then((r) => r.data);

export const createSgi = (body: CreateSgiInput) =>
  api<{ sgi: Sgi }>("/admin/sgis", { method: "POST", body }).then((r) => r.sgi);

export const updateSgi = (id: string, body: Partial<CreateSgiInput> & { active?: boolean }) =>
  api<{ sgi: Sgi }>(`/admin/sgis/${id}`, { method: "PATCH", body }).then((r) => r.sgi);

export interface SgiStats {
  sgi_id: string;
  name: string;
  code: string | null;
  client_count: number;
  transaction_count: number;
  buy_notional: string;
  commissions_collected: string;
  last_trade_date: string | null;
}

export const sgiDashboard = () =>
  api<{ data: SgiStats[] }>("/admin/sgis/dashboard").then((r) => r.data);
